




























































import { PropType } from 'vue';
import { mapActions } from 'vuex';

import { ALForm } from '@/common/component.types';
import { ISystemError } from '@/models/error/error.types';
import {
  WorkflowFormTemplateAttachment,
  IWorkflowFormTemplateRevision,
  IAttachment
} from '@/models';

import { SystemError } from '@/models/error/error';
import { setErrorFromAxiosError } from '@/utils/helpers';

import mixins from '@/utils/mixins';
import FormRules from '@/mixins/file-upload-rules';

import AlDialog from '@/components/core/Dialog/ALDialog.vue';
import DragDropFileInput from '../common/DragDropFileInput.vue';
import ErrorAlert from '../common/ErrorAlert.vue';

const baseMixins = mixins(FormRules);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'WorkflowFormTemplateAddAttachmentsFormDialog',

    components: {
      AlDialog,
      DragDropFileInput,
      ErrorAlert
    },

    props: {
      revision: {
        type: Object as PropType<IWorkflowFormTemplateRevision>,
        required: true
      }
    },

    data() {
      return {
        isDialogActive: false,
        attachmentFormValid: false,

        isLoading: false,

        error: null as ISystemError | null,

        attachment: null as File | null
      };
    },

    methods: {
      ...mapActions({
        addWorkflowFormTemplateAttachment:
          'workflowFormTemplate/addWorkflowFormTemplateAttachment'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      open() {
        this.clearError();
        this.attachment = null;

        this.resetFormValidation();

        this.isDialogActive = true;
      },

      clearError(): void {
        this.error = null;
      },

      close() {
        this.isDialogActive = false;
      },

      uploadAttachment() {
        if (this.validateForm()) {
          this.clearError();

          let attachmentInstance: IAttachment | null = null;

          try {
            attachmentInstance = new WorkflowFormTemplateAttachment({
              file: this.attachment as File
            });
          } catch (error) {
            if (SystemError.isSystemError(error)) {
              this.error = error;
            }
          }

          if (attachmentInstance != null) {
            this.isLoading = true;

            this.addWorkflowFormTemplateAttachment({
              templateId: this.revision.template!.id,
              attachment: attachmentInstance
            })
              .then(() => {
                this.close();
              })
              .catch(error => {
                this.error = setErrorFromAxiosError(error);
              })
              .finally(() => {
                this.isLoading = false;
              });
          }
        }
      }
    }
  });
